/*
Sort functions to assist with tables
 */

import { get, isNaN as loIsNaN } from "lodash-es";
import type { TableRow } from "react-data-table-component";

const sortNumbers =
  (
    propertyName: string,
    undefinedLow = true,
    percentagePropertyName?: string,
  ) =>
  (rowA: TableRow, rowB: TableRow): number => {
    const undefinedValue = undefinedLow
      ? Number.NEGATIVE_INFINITY
      : Number.POSITIVE_INFINITY;
    // The sorted columns hold numbers; get() is untyped over the row, so read
    // the value as a number for the numeric comparison.
    const num = (row: TableRow, prop: string, dflt: number): number =>
      get(row, prop, dflt) as number;
    if (percentagePropertyName) {
      const a =
        num(rowA, propertyName, undefinedValue) /
        num(rowA, percentagePropertyName, 1);
      const b =
        num(rowB, propertyName, undefinedValue) /
        num(rowB, percentagePropertyName, 1);
      return numericCompare(
        loIsNaN(a) ? undefinedValue : a,
        loIsNaN(b) ? undefinedValue : b,
      );
    } else {
      return numericCompare(
        num(rowA, propertyName, undefinedValue),
        num(rowB, propertyName, undefinedValue),
      );
    }
  };

const numericCompare = (a: number, b: number): number => {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
};

export default sortNumbers;
